import React from 'react';
import { HelpCircle, CheckCircle, Square, AlertCircle } from 'lucide-react';

export default function HelpView() {
  const steps = [
    { title: '1. Login Automático', desc: 'Sua assinatura e permissão do setor produtivo serão derivadas de suas credenciais.' },
    { title: '2. Disparar Produção', desc: 'Clique no item operacional para acionar o cronômetro individual do setor.' },
    { title: '3. Registrar Períodos', desc: 'As pausas acumulam tempo incremental em "production_periods" de forma transparente.' },
    { title: '4. Conclusão', desc: 'Conclua a peça para liberá-la para o próximo setor fabril.' }
  ];

  return (
    <div className="fade-in" id="help-page">
      {/* Title */}
      <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
        <div>
          <h1 className="h3 fw-bold text-dark font-display mb-1">Central de Ajuda</h1>
          <p className="text-muted text-xs font-mono mb-0 font-bold">Guia Rápido do Operador Fabril</p>
        </div>
      </div>

      <div className="card shadow-sm border-0 rounded bg-white p-4">
        <h5 className="fw-bold font-display text-dark border-bottom pb-2 mb-3">Fluxo Sequencial das Coifas</h5>
        
        <p className="text-secondary text-sm">
          A fabricação de coifas industriais segue regras estritas para garantir qualidade e evitar avaria ou atraso. 
          Siga o fluxo e salve tempos conforme a rotina:
        </p>

        <div className="row g-3 mt-2">
          {steps.map((s, idx) => (
            <div key={idx} className="col-12 col-md-3">
              <div className="p-3 bg-light rounded border h-100">
                <span className="badge bg-dark font-mono text-xs mb-2">{idx + 1}º PASSO</span>
                <h6 className="fw-bold text-dark font-display mb-1">{s.title}</h6>
                <p className="text-muted text-xs mb-0">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="alert bg-primary-subtle text-primary border-primary border-1 mt-4 p-3 d-flex align-items-start gap-3 rounded mb-0">
          <AlertCircle size={20} className="flex-shrink-0 mt-0.5" />
          <div className="text-xs">
            <strong>DÚVIDAS FREQUENTES:</strong> Se o cronômetro do seu setor ficar agarrado, recarregue a página ou contacte um supervisor 
            com permissão de administrador no ramal 4015.
          </div>
        </div>
      </div>
    </div>
  );
}
